// extracted by mini-css-extract-plugin
export default {"textContainer":"privacy_textContainer__dN7FE","centerAlign":"privacy_centerAlign__8dNHq"};